import ReducersTooling from '../../../tooling/reducersTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';

const initialState = {
  metricsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  dimensionsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  polynomialsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  functionsList: FormulaUtilsTooling.getFunctionsList(),
  dimensionInstancesSelectList: ReducersTooling.initialStates.getFetchTypeInitialState(),
  formulaToEditObject: null,
  formulaValidation: ReducersTooling.initialStates.getFetchTypeInitialState(),
  formulaGrammarValidation: ReducersTooling.initialStates.getFetchTypeInitialState(),
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/formulaEditor/initialState.js